import { IStore } from 'store/types';
import { IAlert } from 'types';

export const selectUserAlert =
  () =>
  (state: IStore): IAlert =>
    state?.collections?.alerts?.data?.[0];
